import { Component, inject } from '@angular/core';
import { JsonPipe } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { UserService } from '../../core/services/user.service';

@Component({
  selector: 'app-debug',
  standalone: true,
  imports: [JsonPipe, TranslatePipe],
  templateUrl: './debug.component.html',
  styleUrl: './debug.component.scss',
})
export class DebugComponent {
  readonly user = inject(UserService).user;
}
